/*
 * Purpose: Flows workspace sub-nav — My flows | Flow Templates
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { Link, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '@/lib/appRoutes';
import { FLOW_TEMPLATES_IA, flowTemplateCount } from '@/lib/flowTemplates';
import { findBuilderNavItem } from '@/lib/productActivities';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';

const MY_FLOWS_LABEL = findBuilderNavItem('flows')?.label ?? 'My flows';

export function FlowsSubNav() {
  const { pathname } = useLocation();
  const onTemplates = pathname.startsWith(APP_ROUTES.flowTemplates);
  const count = flowTemplateCount();

  return (
    <div className="shrink-0 border-b border-border bg-card/60 backdrop-blur-sm -mx-4 sm:-mx-6 px-4 sm:px-6">
      <div className="flex flex-wrap items-center gap-2 py-2">
        <Link
          to={APP_ROUTES.flows}
          className={cn(
            'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
            !onTemplates
              ? 'bg-primary/10 text-primary'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
          )}
        >
          {MY_FLOWS_LABEL}
        </Link>
        <Link
          to={APP_ROUTES.flowTemplates}
          className={cn(
            'inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
            onTemplates
              ? 'bg-primary/10 text-primary'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
          )}
        >
          {FLOW_TEMPLATES_IA.label}
          <Badge variant="secondary" className="text-[10px] px-1.5 py-0 h-5 font-normal">
            {count}
          </Badge>
        </Link>
        <p className="hidden lg:block text-xs text-muted-foreground ml-auto max-w-md">
          {onTemplates ? FLOW_TEMPLATES_IA.description : 'Saved flows you own — open Map to edit or Mission to run.'}
        </p>
      </div>
    </div>
  );
}

export default FlowsSubNav;
